// extracted by mini-css-extract-plugin
export default {"scope":"D7GlE","actions":"KoZIw","filters":"lV-u0"};